import React from 'react';
import Navbar from './components/Navbar';
import './App.css';
import Home from './components/pages/Home';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Services from './components/pages/Services';
import CustomerDemand from './components/pages/CustomerDemand';
import SignUp from './components/pages/SignUp';
import Announcement from 'react-announcement'
import EcommerceHome from './E-pages/EcommerceHome';
import Product from './E-components/Product';
import ProductList from './E-pages/ProductList';
import Register from './E-pages/Register';
import Login from './E-pages/Login';
import Cart from './E-pages/Cart';
function App() {
  return (
    <>
      <Router>
      <Announcement
          title="這是Shuper Demo 測試網站"
          subtitle="只為展示，尚未上架，以先製作電腦版為主手機版慢慢補上"
          link=""
          imageSource='../images/announcement-logo.png'
          daysToLive={0}
          secondsBeforeBannerShows={1}
          closeIconSize={30}
      />
        <Switch>
          <Route path='/' exact component={Home} />
          <Route path='/services' component={Services} />
          <Route path='/customerdemand' component={CustomerDemand} />
          <Route path='/commerce' component={EcommerceHome} />
          <Route path='/sign-up' component={SignUp} />
          <Route path="/commerce/product/:id">
            <Product />
          </Route>
          <Route path="/commerce/products/:category">
                <ProductList  />
          </Route>
          
          <Route path="/commerce/register">
                <Register/>
          </Route>
          <Route path="/commerce/login">
              <Login/>
          </Route>
          <Route path="/commerce/cart">
                <Cart/>
          </Route>



        </Switch>
      </Router>
    </>
  );
}

export default App;
